import CheckboxList from "./Default/CheckboxList.jsx"

export default function AdditionalQuestions({selected, setSelected}) {
  const options = [
    { value: "has_med_book", label: "Есть медкнижка" },
  ];

  return (
    <CheckboxList
      label="Выберите опции"
      options={options}
      selectedValues={selected}
      setSelectedValues={setSelected}
    />
  );
}
